import {
  Configuration,
  LogLevel,
  PublicClientApplication,
} from "@azure/msal-browser";

const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`,
    redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI || window.location.origin,
    // We use loginRedirect (see AuthContext.tsx). With the default `true`,
    // MSAL would, after consuming the response at redirectUri ("/"), navigate
    // back to the page sign-in started from ("/login") — an extra hop that
    // re-engages the router and risks re-introducing the hash-strip race.
    // `false` makes MSAL process the response in place on this load; main.tsx
    // then records the provider and our own router sends the user onward.
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (import.meta.env.DEV) {
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              break;
            case LogLevel.Warning:
              console.warn(message);
              break;
          }
        }
      },
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

// `offline_access` ensures Azure AD v2 returns a refresh token so sessions
// survive the 1h access-token lifetime without forcing the user back through
// the login UI. The same base scopes are prepended in the extension (see
// packages/frontend/extension/config.ts) for parity.
const BASE_SCOPES = ["openid", "profile", "email", "offline_access"];

/** Split the `VITE_CARE_MANAGEMENT_GQL_SCOPES` env value on any whitespace. */
function parseApiScopes(raw: string | undefined): string[] {
  if (!raw) return [];
  return raw.split(/\s+/).map((s) => s.trim()).filter(Boolean);
}

export const apiScopes: string[] = parseApiScopes(
  import.meta.env.VITE_CARE_MANAGEMENT_GQL_SCOPES,
);

export const loginRequest = {
  scopes: apiScopes.length > 0 ? [...BASE_SCOPES, ...apiScopes] : BASE_SCOPES,
};
